import React, {useCallback} from 'react';
import {Box} from '@mui/material';
import {useRouter} from 'src/routes/hooks';
import {paths} from 'src/routes/paths';
import NoteItems from './Notecard';
interface FileToUpload {
  ids: string;
  fileData: string; // Assuming base64-encoded string of the file's data
  fileName: string; // The name of the file
  fileType: string; // The MIME type of the file
  fileError: string;
}
// eslint-disable-next-line
interface WrittenData {
  id: string;
  title: string;
  description: string;
  date: string;
  isFavorited: boolean;
  attachmentName?: FileToUpload[];
}
interface Note {
  id: string;
  title: string;
  description: string;
  date: string;
  isFavorited: boolean;
  attachmentName?: FileToUpload[];
}

// interface NoteCardProps {
//   note: Note;
// }

// const NoteCard: React.FC<NoteCardProps> = ({note}) => {
//   return (
//     <Card sx={{maxWidth: 345, m: 1, backgroundColor: 'lightgray'}}>
//       {' '}
//       {/* Adjust max width and margin as needed */}
//       <CardContent>
//         <Typography color="textSecondary" gutterBottom>
//           {note.date}
//         </Typography>
//         <Typography variant="h5" component="h2">
//           {note.dataname}
//         </Typography>
//         <Typography color="textSecondary">{note.description}</Typography>
//         <CardActions disableSpacing>
//           {note.attachmentName &&
//             note.attachmentName.map((attachment, index) => (
//               <IconButton key={index} aria-label={`attachment-${index}`}>
//                 {attachment.fileName}
//                 <AttachmentIcon />
//                 {/* Display the file name */}
//               </IconButton>
//             ))}
//         </CardActions>
//       </CardContent>
//     </Card>
//   );
// };

const NotesList: React.FC<{notes: Note[]; setnotes: any}> = ({
  notes,
  setnotes
}) => {
  const router = useRouter();
  // const [data, setData] = React.useState<Note[]>(notes);
  const handleView = useCallback(
    (id: string) => {
      router.push(paths.dashboard.job.details(id));
    },
    [router]
  );

  const handleEdit = useCallback(
    (id: string) => {
      router.push(paths.dashboard.job.edit(id));
    },
    [router]
  );

  const handleDelete = useCallback((id: string) => {
    setnotes((prev: any[]) =>
      prev.filter((job: {id: string}) => job.id !== id)
    );
  }, []);
  return (
    <Box
      gap={3}
      sx={{paddingY: '2vh'}}
      display="grid"
      gridTemplateColumns={{
        xs: 'repeat(4, 1fr)',
        sm: 'repeat(5, 1fr)',
        md: 'repeat(6, 1fr)'
      }}>
      {notes.map(job => (
        <NoteItems
          key={job.id}
          job={job}
          onView={() => handleView(job.id)}
          onEdit={() => handleEdit(job.id)}
          onDelete={() => handleDelete(job.id)}
        />
      ))}
    </Box>

    // <Box display="flex" flexDirection="row" flexWrap="wrap">
    //   {notes.map((note) => (
    //     <NoteCard key={note.id} note={note} />
    //   ))}
    // </Box>
  );
};

export default NotesList;
